<div *ngIf="googleRecaptchaKey" class="recaptcha-input-container">
  <div class="recaptcha-stack z-index-2">
    <re-captcha #recaptchaComponent
      (resolved)="handleCaptchaResolved($event)"
      [siteKey]="googleRecaptchaKey"
    ></re-captcha>
  </div>
  <div class="recaptcha-stack z-index-1">
    <lcp-loading loadingType="contain"></lcp-loading>
  </div>
</div>

<div class="fieldset-error"
  *ngIf="error">
    Please complete the above robot check
</div>
